module.exports = __webpack_public_path__ + "img/92115.976a1640.svg";